interface ISTOCK_FORMULA {
  firstPurchase: number;
  firstQuantity: number;
  secondPurchase: number;
  secondQuantity: number;
}

export const STOCK_FORMULA = ({
  firstPurchase,
  firstQuantity,
  secondPurchase,
  secondQuantity,
}: ISTOCK_FORMULA) => {
  const fp = Number(firstPurchase);
  const fq = Number(firstQuantity);
  const sp = Number(secondPurchase);
  const sq = Number(secondQuantity);

  if (
    fp < 0 ||
    fp > 1e10 ||
    fq < 0 ||
    fq > 1e10 ||
    sp < 0 ||
    sp > 1e10 ||
    sq < 0 ||
    sq > 1e10
  ) {
    const res = 0;
    return {
      averagePrice: res.toFixed(2),
      totalQuantity: res.toFixed(0),
      totalInvestment: res.toFixed(2),
    };
  }
  const firstInvest = fp * fq;
  const secondInvest = sp * sq;
  const totalInv = firstInvest + secondInvest;
  const quant = fq + sq;
  let average;
  quant == 0 ? (average = 0) : (average = totalInv / quant);
  return {
    averagePrice: average.toFixed(2),
    totalQuantity: quant.toFixed(0),
    totalInvestment: totalInv.toFixed(2),
  };
};
